import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
import { OrderType } from "./OrderService";
setupInterceptorsTo(axios);

export enum PaymentStatuses {
    PENDING = 1,
    VALIDATED = 2,
    BAD_HOLDERS = 4,
    CANCELLED = 5
}

interface IPayment
{
    id?: number,
    usersSubscriptionId?: number,
    savingsPlanId?: number,
    amount: number,
    reference: string,
    frequency?: string,
    countryBank?: string,
    bank?: string,
    account?: string,
    startDate?: string,
    endDate?: string,
    status: number,
    subject: string,
    platform: string,
    orders?: OrderType[],
    inespayId?: string,
    createdAt?: string
}

export type PaymentType = IPayment

class PaymentService
{
    public getPayment = async (paymentId: number): Promise<PaymentType> =>
    {
        let url: string = `${proxyUrl}/payments/${paymentId}`;
        const req = await axios.get(url);
        return req.data;
    }

    public createPayment = async (payment: PaymentType): Promise<Partial<PaymentType>> =>
    {
        let url: string = `${proxyUrl}/payments`;
        const req = await axios.post(url, payment);
        return req.data;
    }

    public createPaymentFromCompetition = async (payment: PaymentType, idCompetition: number): Promise<Partial<PaymentType>> =>
        {
            let url: string = `${proxyUrl}/payments?competitionUserId=${idCompetition}`;
            const req = await axios.post(url, payment);
            return req.data;
        }

    public putPayment = async (paymentId: number, payment: PaymentType): Promise<PaymentType> =>
    {
        let url: string = `${proxyUrl}/payments/${paymentId}`;
        const req = await axios.put(url, payment);
        return req.data;
    }
}

const payment = new PaymentService();
export default payment;